
import { Options } from "vue-class-component";
import ComponentConfigMixins from "../ComponentConfigMixins";

@Options({
    name: "flowable-common-form-components-date-time-config",
})
export default class DateTimeConfig extends ComponentConfigMixins {}
